import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise, AxiosRequestConfig } from 'axios'
import { searchConfig, TableDataConfig } from '@pt/api/advapp/index.type'

export function productList(
  data?: Partial<searchConfig> & { keyword?: string },
  options: AxiosRequestConfig = {},
): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/list`,
    method: 'get',
    params: data,
    ...options,
  })
}

export function productDel(id: number): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/del?id=${id}`,
    method: 'get',
  })
}

export function productSave(data: TableDataConfig): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/save`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function productUpdate(data: TableDataConfig): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/update`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function productRefresh(id: number): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/refresh?id=${id}`,
    method: 'get',
  })
}
